import React from 'react';
import { Link } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';
import { OptionalRolesOrPermissions } from '../helpers/Permissions';

type Props = {
    url: string;
    onlyIcon?: boolean;
    buttonText?: string | null;
} & OptionalRolesOrPermissions;

function CreateButton({ url, roles = [], permissions = [], onlyIcon = false, buttonText = null }: Props) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <Link className="btn btn-primary btn-sm" key="create" to={url}>
            <i className="mdi mdi-plus" /> {!onlyIcon ? buttonText || 'Create' : ''}
        </Link>
    ) : null;
}

export default CreateButton;
